import { getUser, getStripeCustomer } from '../graphql/queries';
import { updateUser } from '../graphql/mutations.js';
import { API,Cache, Auth } from 'aws-amplify';

async function authChecker(setDialogModalMessage, setDialogModalOpen, navigate) {
    let cognitoUser = await Auth.currentAuthenticatedUser();
      
    const { attributes } = cognitoUser;
    const payload = cognitoUser.signInUserSession?.idToken?.payload || {};

    const email = attributes?.email || payload?.email;

    if (!email) {
      throw new Error("Email not available from Cognito user attributes or token payload.");
    }

    const result = await API.graphql({ query: getUser , variables:{id: email}});

    if(result['data'].getUser !=null && result['data'].getUser.refreshToken !=null){
      
    }else{
        setDialogModalMessage("Aitium requires authorization on Amazon Seller Central. Redirecting to authorization page...");
        setDialogModalOpen(true);
        navigate("/authorize");
        return false;
    }

}

export const validateSubscription = async (setSubscriptionPlan, setSubscriptionLoading, setDialogModalMessage, setDialogModalOpen, navigate) => {
    let cognitoUser = await Auth.currentAuthenticatedUser();
      
    
    const { attributes } = cognitoUser;
    const payload = cognitoUser.signInUserSession?.idToken?.payload || {};

    const email = attributes?.email || payload?.email;

    if (!email) {
      throw new Error("Email not available from Cognito user attributes or token payload.");
    }

    const result = await API.graphql({ query: getUser , variables:{id:email}});

    const userData = result.data.getUser;

    if (userData.customerAWSAccountId){
        authChecker(setDialogModalMessage, setDialogModalOpen, navigate);
        setSubscriptionLoading(false);
    }else if(!userData.stripeId) {
        setDialogModalMessage("Aitium requires stripe subscription. Please subscribe first. Redirecting to subscription page...");
        setDialogModalOpen(true);
        setSubscriptionLoading(false);
        navigate("/products");
        
    } 
    else {

        if(userData.stripeId) {
            var response = await API.graphql({
                query: getStripeCustomer
                ,variables : {"email": email, "stripeCustomerId": userData.stripeId}
            })
            const stripeData = JSON.parse(response["data"]["getStripeCustomer"]);
            
            var currentPlan = null;
            var currentCustomer = null;
    
            //find the exact plan they are on currently
            if(stripeData['body'] && stripeData['body']['data']){
              for(var i = 0; i < stripeData['body']['data'].length;i++){
                currentCustomer = stripeData['body']['data'][i];
                if(currentCustomer && currentCustomer['customer'] == userData.stripeId){
                  //found the current plan 
                  currentPlan = stripeData['body']['data'][i]['plan'];
                  setSubscriptionPlan(currentPlan['product']);
                }
              }
            }
            setSubscriptionLoading(false);
        }

        authChecker(setDialogModalMessage, setDialogModalOpen, navigate);
        setSubscriptionLoading(false);
    }
};